import { render, staticRenderFns } from "./UpdateRequested.vue?vue&type=template&id=92a81ff0"
import script from "./UpdateRequested.vue?vue&type=script&lang=js"
export * from "./UpdateRequested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports